import React from 'react';
import { Select, Space, Typography } from 'antd';
import { ALL_MONTH_KEYS } from './computeUsedLocationPercent';

const { Text } = Typography;

interface MonthRangeSelectProps {
  monthFrom: string;
  monthTo: string;
  onChange: (from: string, to: string) => void;
}

export const MonthRangeSelect: React.FC<MonthRangeSelectProps> = ({
  monthFrom,
  monthTo,
  onChange,
}) => {
  const fromIndex = ALL_MONTH_KEYS.indexOf(monthFrom);
  const toIndex = ALL_MONTH_KEYS.indexOf(monthTo);

  const handleFrom = (value: string) => {
    const newFromIdx = ALL_MONTH_KEYS.indexOf(value);
    const newToIdx = ALL_MONTH_KEYS.indexOf(monthTo);
    if (newFromIdx > newToIdx) {
      onChange(value, value);
    } else {
      onChange(value, monthTo);
    }
  };

  const handleTo = (value: string) => {
    const newToIdx = ALL_MONTH_KEYS.indexOf(value);
    const newFromIdx = ALL_MONTH_KEYS.indexOf(monthFrom);
    if (newToIdx < newFromIdx) {
      onChange(value, value);
    } else {
      onChange(monthFrom, value);
    }
  };

  return (
    <Space wrap align="center">
      <Text type="secondary">Month range:</Text>
      <Select
        size="small"
        style={{ width: 120 }}
        value={monthFrom}
        onChange={handleFrom}
        options={ALL_MONTH_KEYS.map((m) => ({ label: m, value: m }))}
      />
      <Text type="secondary">to</Text>
      <Select
        size="small"
        style={{ width: 120 }}
        value={monthTo}
        onChange={handleTo}
        options={ALL_MONTH_KEYS.filter((_, i) => i >= fromIndex).map((m) => ({ label: m, value: m }))}
      />
      {fromIndex >= 0 && toIndex >= 0 && (
        <Text type="secondary">({toIndex - fromIndex + 1} months)</Text>
      )}
    </Space>
  );
};
